import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, QuoteIcon } from 'lucide-react';
export function TransformationSection() {
  const points = ['Enseñarle a competir con más calma, claridad y seguridad mental.', 'Ayudarlo a recuperarse mejor del error sin derrumbarse por dentro.', 'Acompañarlo desde casa con herramientas concretas, sin invadir ni meter más presión.', 'El fútbol vuelva a ser un espacio de crecimiento, no de sufrimiento constante.'];
  return <section className="py-20 md:py-28 bg-white relative overflow-hidden" data-id="element-232">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="max-w-2xl mx-auto text-center mb-16 md:mb-24" data-id="element-234">
          <QuoteIcon className="w-8 h-8 text-brand-slate/20 mx-auto mb-6" data-id="element-235" />
          <h3 className="md:text-3xl font-heading text-brand-slate italic text-[24px]" data-id="element-236">
            Cuanto antes empieces a ayudarlo, más fácil le será recuperar su
            juego
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-237">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} data-id="element-238">
            <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-6 leading-tight" data-id="element-239">
              Por eso creamos{' '}
              <span className="text-brand-amber" data-id="element-240">Competir sin Miedo</span>
            </h2>
            <p className="text-base md:text-lg text-brand-slate-light mb-8 leading-relaxed" data-id="element-241">
              Una guía práctica de fortaleza mental para futbolistas jóvenes y
              sus familias, diseñada para ayudarte a:
            </p>

            <ul className="space-y-5" data-id="element-242">
              {points.map((point, index) => <li key={index} className="flex items-start" data-id="element-243">
                  <CheckCircle2Icon className="w-5 h-5 text-brand-amber flex-shrink-0 mr-3 mt-1" data-id="element-244" />
                  <span className="text-brand-slate-light text-base md:text-lg leading-relaxed" data-id="element-245">
                    {point}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="relative" data-id="element-246">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-gray-100" data-id="element-247">
              <img src="https://cdn.magicpatterns.com/uploads/thWFT5rVF6Y9KdMETwdMpf/WhatsApp_Image_2026-04-01_at_19.32.35.jpg" alt="Joven futbolista compitiendo en partido" className="w-full h-full object-cover" loading="lazy" data-id="element-248" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}